var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/tag/common/src/tag-classes.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var getTagRootClasses = ({
  cssClasses,
  overrideClasses,
  className
}) => cx(cssClasses.root, className, overrideClasses == null ? void 0 : overrideClasses.root, "gs-tag");
var getTagButtonClasses = ({
  cssClasses,
  overrideClasses
}) => cx(cssClasses.button, overrideClasses == null ? void 0 : overrideClasses.button, "gs-tag__button");

// components/tag/common/src/tag-color.ts
import { colorNames } from "@gs-ux-uitoolkit-common/design-system";
var tagColors = colorNames;

// components/tag/common/src/tag-common-props.ts
var defaultTagProps = {
  color: "blue",
  emphasis: "bold",
  size: "md",
  shape: "rounded"
};

// components/tag/common/src/tag-toggle-common-props.ts
var defaultTagToggleProps = __spreadProps(__spreadValues({}, defaultTagProps), {
  defaultSelected: false
});

// components/tag/common/src/tag-emphasis.ts
var tagEmphases = ["bold", "subtle", "minimal"];

// components/tag/common/src/tag-shape.ts
var tagShapes = ["rounded", "square"];

// components/tag/common/src/tag-size.ts
var tagSizes = ["xs", "sm", "md", "lg"];

// components/tag/common/src/tag-status.ts
var tagStatuses = ["none", "information", "success", "warning", "error"];

// components/tag/common/src/tag-style-sheet.ts
import { colors } from "@gs-ux-uitoolkit-common/design-system";
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import {
  createComponentClassDefinitions
} from "@gs-ux-uitoolkit-common/theme";
var tagStyleSheet = new StyleSheet("tag", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.tag
  );
});
function getTypographyMap(theme) {
  return {
    xs: __spreadValues({}, theme.typography.caption01),
    sm: __spreadValues({}, theme.typography.body03),
    md: __spreadValues({}, theme.typography.body02),
    lg: __spreadValues({}, theme.typography.body02)
  };
}
var padding = {
  xs: 8,
  sm: 12,
  md: 12,
  lg: 16
};
var paddingMinimal = {
  xs: padding.xs - 1,
  sm: padding.sm - 1,
  md: padding.md - 1,
  lg: padding.lg - 1
};
var height = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 32
};
function getLineHeight(size, isMinimal) {
  if (size === "xs") {
    return height[size] + (isMinimal ? -1 : 1);
  }
  if (size === "sm") {
    return height[size] + (isMinimal ? 0 : 1);
  }
  return height[size] + (isMinimal ? 0 : 1);
}
var borderRadius = {
  rounded: "200px",
  square: "2px"
};
function getInteractionShades({
  theme,
  emphasis,
  color,
  selected,
  isToggle
}) {
  if (isToggle) {
    if (!selected && emphasis !== "minimal") {
      return theme.getColorInteractionShades("gray", "subtle");
    }
    if (selected && emphasis === "subtle") {
      return theme.getColorInteractionShades(color, color === "gray" ? "bold" : "subtle");
    }
  }
  if (selected && emphasis === "subtle") {
    return theme.getColorInteractionShades(color, "bold");
  }
  if (selected && emphasis === "minimal") {
    return theme.getColorInteractionShades(color, "subtle");
  }
  return theme.getColorInteractionShades(color, emphasis);
}
function determineMainColor({ emphasis, hover, active, selected, isToggle }, shades) {
  if (active) {
    return shades.active;
  }
  if (hover) {
    return shades.hover;
  }
  if (!isToggle && selected && emphasis === "bold") {
    return shades.active;
  }
  return shades.background;
}
function determineColorFromStatus(status) {
  switch (status) {
    case "none":
      return "gray";
    case "information":
      return "blue";
    case "success":
      return "green";
    case "warning":
      return "orange";
    case "error":
      return "red";
    default:
      return void 0;
  }
}
function createDefaultStyledClasses({
  theme,
  isToggle = false,
  focussed = false,
  hover = false,
  active = false,
  disabled = false,
  dismissible = false,
  emphasis = defaultTagProps.emphasis,
  size = defaultTagProps.size,
  shape = defaultTagProps.shape,
  selected = false,
  color = "blue",
  status
}) {
  const cssProps = {
    theme,
    isToggle,
    focussed,
    hover,
    active,
    disabled,
    dismissible,
    emphasis,
    size,
    shape,
    selected,
    // `status`, if defined, takes precedence over `color`:
    color: determineColorFromStatus(status) || color
  };
  const isXs = size === "xs";
  const isMinimal = emphasis === "minimal";
  const shades = getInteractionShades(cssProps);
  const mainColor = determineMainColor(cssProps, shades);
  const focusBorder = {
    content: focussed ? '""' : "none",
    position: "absolute",
    zIndex: 1,
    left: "-3px",
    top: "-3px",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: borderRadius[shape],
    padding: "2px"
  };
  const borderColorProps = __spreadProps(__spreadValues({}, cssProps), {
    selected: false,
    isToggle: false,
    emphasis: "bold"
  });
  const borderColor = determineMainColor(
    borderColorProps,
    getInteractionShades(borderColorProps)
  );
  const margin = "8px";
  const sidePadding = isMinimal ? paddingMinimal[size] : padding[size];
  return {
    root: {
      position: "relative",
      backgroundColor: mainColor,
      borderRadius: borderRadius[shape],
      display: "inline-flex",
      height: height[size],
      boxSizing: "border-box",
      opacity: disabled ? 0.3 : 1,
      // Tags are designed to be rendered inline adjacent to other Tags. Therefore their
      // spacing against each other should "just work" without each use of Tags
      // requiring custom margins to be defined.
      margin: `0 ${margin} ${margin} 0`,
      // Focus ring set to main "bold" color for all emphases.
      "&::before": __spreadProps(__spreadValues({}, focusBorder), {
        borderColor
      })
    },
    button: __spreadProps(__spreadValues({
      height: height[size]
    }, getTypographyMap(theme)[size]), {
      color: shades.text,
      borderRadius: borderRadius[shape],
      background: "transparent",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: `${sidePadding}px`,
      // 19px for "xs" because 3px are added to CloseButton right:
      paddingRight: `${sidePadding + (dismissible ? isXs ? 19 : 16 : 0)}px`,
      boxSizing: "border-box",
      cursor: disabled ? "default" : "pointer",
      userSelect: "none",
      whiteSpace: "nowrap",
      // IMPORTANT! button needs to be exposed on the top so button must have
      // a z-index property higher than root::before element. Fixing (UX-19468)
      // bug when user can't toggle tag on mobile devices
      position: "relative",
      zIndex: 2,
      // Improve the vertical alignment of the text label:
      lineHeight: `${getLineHeight(size, isMinimal)}px`,
      // Non-focussed minimal has a border:
      border: isMinimal ? focussed ? "1px solid transparent" : `1px solid ${selected ? borderColor : colors.gray040}` : "none",
      "&:focus": {
        outline: "none"
      }
    }),
    closeRoot: {
      position: "absolute",
      top: 0,
      // CloseButton has 8px padding, but ensure right is at least 3px
      // to avoid overflowing out of the Tag out on the right:
      right: `${Math.max(3, sidePadding - 8)}px`,
      lineHeight: 1
    },
    closeButton: {
      height: height[size],
      overflow: "hidden",
      display: "block",
      position: "relative",
      zIndex: 2,
      ".gs-icon": {
        fontSize: "13px",
        transform: "translateY(-1px)"
        // vertically aligns the "x" better
      }
    },
    closeIcon: {},
    content: {}
  };
}
export {
  defaultTagProps,
  defaultTagToggleProps,
  getTagButtonClasses,
  getTagRootClasses,
  tagColors,
  tagEmphases,
  tagShapes,
  tagSizes,
  tagStatuses,
  tagStyleSheet
};
//# sourceMappingURL=index.mjs.map
